export function formatAttendancePolicyV2Limit({
  totalSubRequestAllowance,
  shortNoticeSubRequestAllowance,
}: {
  totalSubRequestAllowance: number;
  shortNoticeSubRequestAllowance: number;
}): string {
  const classLabel = totalSubRequestAllowance === 1 ? 'class' : 'classes';
  return `${totalSubRequestAllowance} ${classLabel} (max ${shortNoticeSubRequestAllowance} short-notice)`;
}
